import { Card, Box, Typography, Divider, Skeleton } from '@mui/material'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useQuery } from 'react-query'

// Local Import

// API services
import { getLeavePolicies } from 'services/api/modules/leave/leavePolicy'
import AdxButton from 'components/custom/AdxButton'

const LeaveCreditRequest = () => {
  let navigate = useNavigate()

  const { data, isLoading } = useQuery(['leave-policy', { type: 3 }], async () => {
    const { data: apiData } = await getLeavePolicies()
    return apiData.data.leave_credit[0]
  })

  const approvalRoute = data?.approval_route[0] || {}
  const routes = [
    approvalRoute.layer_one,
    approvalRoute.layer_two,
    approvalRoute.layer_three,
    approvalRoute.layer_four,
    approvalRoute.layer_five,
  ].filter(Boolean)

  return (
    <Card
      variant="outlined"
      sx={{
        boxSizing: 'border-box',
        borderRadius: '4.5px',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          justifyContent: 'space-between',
          width: 1,
        }}
        p={2}
      >
        <Box sx={{ width: { xs: 1, sm: 1 / 2 } }}>
          <Typography sx={{ fontWeight: 'medium' }} variant="subtitle1">
            Documentation
          </Typography>
        </Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: { xs: 'flex-start', sm: 'flex-end' },

            width: { xs: 1, sm: 1 / 2 },
          }}
        >
          {isLoading ? (
            <Skeleton width={'100%'} />
          ) : data?.attachment_required === 1 ? (
            <Typography variant="subtitle1" color={'alternate.main'}>
              Required
            </Typography>
          ) : (
            <Typography variant="subtitle1" color={'dark-gray-text.main'}>
              Not Required
            </Typography>
          )}
        </Box>
      </Box>
      <Divider variant="full" />
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          justifyContent: 'space-between',
          width: 1,
        }}
        p={2}
      >
        <Box sx={{ width: { xs: 1, sm: 1 / 2 } }}>
          <Typography sx={{ fontWeight: 'medium' }} variant="subtitle1">
            Reasoning
          </Typography>
        </Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: { xs: 'flex-start', sm: 'flex-end' },

            width: { xs: 1, sm: 1 / 2 },
          }}
        >
          {isLoading ? (
            <Skeleton width={'100%'} />
          ) : data?.reason_required === 1 ? (
            <Typography variant="subtitle1" color={'alternate.main'}>
              Required
            </Typography>
          ) : (
            <Typography variant="subtitle1" color={'dark-gray-text.main'}>
              Not Required
            </Typography>
          )}
        </Box>
      </Box>
      <Divider variant="full" />

      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          justifyContent: 'space-between',
          width: 1,
        }}
        p={2}
      >
        <Box sx={{ width: { xs: 1, sm: 1 / 2 } }}>
          <Typography sx={{ fontWeight: 'medium' }} variant="subtitle1">
            Credit Expiry Period
          </Typography>
        </Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: { xs: 'flex-start', sm: 'flex-end' },

            width: { xs: 1, sm: 1 / 2 },
          }}
        >
          {isLoading ? (
            <Skeleton width={'100%'} />
          ) : (
            <Box
              display={'flex'}
              flexDirection={{ xs: 'column', lg: 'row' }}
              alignItems={{ xs: 'null', lg: 'center' }}
              justifyContent={'flex-end'}
            >
              <Typography
                sx={{ fontWeight: 'medium' }}
                color={'dark-gray-text.main'}
                variant="subtitle1"
              >
                {data?.credit_expiry_period_name == 'Day'
                  ? `${data?.credit_expiry_amount} 
                     ${data?.credit_expiry_period_name}${data?.credit_expiry_amount !== 1 && 's'}`
                  : data?.credit_expiry_period_name}
              </Typography>
            </Box>
          )}
        </Box>
      </Box>

      <Divider variant="full" />
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          justifyContent: 'space-between',
          width: 1,
          alignItems: 'center',
        }}
        p={2}
      >
        <Box sx={{ width: { xs: 1, sm: 1 / 4 } }}>
          <Typography sx={{ fontWeight: 'medium' }} variant="subtitle1">
            Approval Route
          </Typography>
        </Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: { xs: 'flex-start', sm: 'flex-end' },
          }}
        >
          {isLoading ? (
            <Skeleton width={'100%'} />
          ) : (
            <Box
              display={'flex'}
              flexDirection={{ xs: 'column', lg: 'row' }}
              alignItems={{ xs: 'null', lg: 'center' }}
              justifyContent={'flex-end'}
              width={1}
            >
              <Typography
                sx={{ fontWeight: 'medium' }}
                color={'light-gray-text.main'}
                variant="subtitle1"
              >
                {routes.map((route, index, arr) => {
                  if (arr.length - 1 === index) {
                    return route.name
                  } else {
                    return `${route.name} > `
                  }
                })}
              </Typography>
            </Box>
          )}
        </Box>
      </Box>

      <Divider variant="full" />
      <Box sx={{ p: 0.5 }}>
        <AdxButton
          variant={'ghost'}
          sx={{
            display: 'flex',
            justifyContent: 'center',
            width: '100%',
          }}
          onClick={() => {
            navigate('/app/management-centre/company-management/leave/edit-leave-credit')
          }}
        >
          Manage leave credit policy
        </AdxButton>
      </Box>
    </Card>
  )
}

export default LeaveCreditRequest
